{
  "ascending": "възходящ",
  "ascendingSort": "сортирано по колона {columnName} във възходящ ред",
  "columnSize": "{value} пиксела",
  "descending": "низходящ",
  "descendingSort": "сортирано по колона {columnName} в низходящ ред",
  "select": "Изберете",
  "selectAll": "Изберете всичко",
  "sortable": "сортираща колона"
}
